import {createSelector, createStructuredSelector, groupBy, sortBy} from 'helpers';
import {flatten, filter, id} from 'store/common';
import {createRestrictedSelector} from 'store/permissions';
import {sort} from './settings';
import {saved} from "store/server";
import {editable} from "store/relations";

export const index = state => state.lists.index;

export const lists = createSelector(
  [ index, sort, filter, createRestrictedSelector(index, 'lists') ],
  ( index, sort ) => {
    let lists = sortBy.apply(null, [ index, ...sort ]);
    return flatten(lists);
  }
);

export const list = createSelector(
  [ index, id ],
  ( index, id ) => index[id],
);

export const listItems = state => state.lists.listItems;

export const itemById = createSelector(
  [ listItems, id ],
  ( listItems, id ) => listItems[id],
);

export const listItemsByListId = createSelector(
  [listItems],
  (listItems) => groupBy(listItems, listItem => listItem.listId)
);

const items = createSelector(
  [ list, listItemsByListId ],
  ( list, listItemsByListId ) => {
    if (list && list.id) {
      let items = listItemsByListId[list.id];
      if (items) {
        let active = sortBy(items.filter(item => item.status !== 'Completed'), ['created']);
        let completed = sortBy(items.filter(item => item.status === 'Completed'), ['created']);
        return active.concat(completed);
      }
    }
    return [];
  }
);

export const details = createStructuredSelector({
  list,
  editable,
  saved,
  items,
});
